import { useState } from 'react';
import { ProductListSort } from '@/types/api';
import { Button } from '@/features/button';
import { IconSort } from '@/features/icons';
import { Modal } from '@/features/modal';
import { SORT_TITLES } from '../constants';
interface Props {
  isSelected: boolean;
  defaultSelected: ProductListSort;
  changeHandler: (newState: ProductListSort) => void;
}
const MobileSortList = ({
  isSelected,
  defaultSelected,
  changeHandler
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);
  const handelChange = (value: ProductListSort) => {
    changeHandler(value);
    handleClose();
  };
  return <>
            <Button onClick={handleOpen} size='xsmall' icon={{
      position: 'right',
      element: <IconSort className='h-5 w-5 lg:h-6 lg:w-6' />
    }} graphicStyle='text' data-sentry-element="Button" data-sentry-source-file="mobile-sort-list.tsx">
                {isSelected ? SORT_TITLES[defaultSelected] : 'مرتب سازی'}
            </Button>

            <Modal handleClose={handleClose} isOpen={isOpen} title='مرتب‌سازی بر اساس' data-sentry-element="Modal" data-sentry-source-file="mobile-sort-list.tsx">
                <div className='mt-6 flex flex-col gap-2 text-body-14 text-text-black'>
                    {Object.keys(ProductListSort).map(item => <span key={item} role='button' className='cursor-pointer' onClick={() => handelChange(item as ProductListSort)}>
                            {SORT_TITLES[item as ProductListSort]}
                        </span>)}
                </div>
            </Modal>
        </>;
};
export default MobileSortList;